import { defineAsyncComponent } from "vue";
const de = {
  richtextEditor: {
    words: "Wörter",
    chars: "Buchstaben",
    heading2: "Überschrift 2",
    heading3: "Überschrift 3",
    paragraph: "Fließtext",
    fullHTML: "Auf vollständiges HTML umschalten",
    fullHTMLScriptCode: "Volles HTML oder Script Code hier einfügen",
    markAffiliate: "Als Affiliate markieren",
    noCKEditor: 'CKEditor ist nicht verfügbar, da einige Tags (z.B. "script") nicht unterstüzt werden. Durch Aktivieren könnten Daten verloren gehen.',
    useAnyway: "CKEditor trotzdem nutzen"
  }
};
const en = {
  richtextEditor: {
    words: "Words",
    chars: "Characters",
    heading2: "Heading 2",
    heading3: "Heading 3",
    paragraph: "Paragraph",
    fullHTML: "Switch to full HTML",
    fullHTMLScriptCode: "Enter full HTML or script code",
    markAffiliate: "Mark as affiliate",
    noCKEditor: 'CKEditor is not available, because some tags (e.g. "script") are not available in CKEditor. If you decide to activate it anyway, it may result in data loss.',
    useAnyway: "Use CKEditor anyway"
  }
};
const messages = { en, de };
const RichTextEditor = defineAsyncComponent(() => import("./richText.editor-DJgmfFjZ.js"));
const richTextModule = {
  routes: [],
  messages
};
export {
  RichTextEditor,
  richTextModule
};
//# sourceMappingURL=index.es.js.map
